export function isAllowedCachePageReload () {
  return localStorage.getItem('prev_page_url').indexOf('/main/html/rd/') > -1 && Number(localStorage.getItem('cache_page_num')) > 2;
}

export function removeAllLocalStorage () {
  localStorage.removeItem('prev_page_url');
  localStorage.removeItem('cache_page_num');
  localStorage.removeItem('scroll_top');
}

export const storagedCacheNum = Number(localStorage.getItem('cache_page_num'));

export function setLocalStorageWhenLeaving (isPageLatestOrSearch, page) {
  localStorage.setItem('prev_page_url', document.location.href);
  if (isPageLatestOrSearch) {
    localStorage.setItem('cache_page_num', page);
    localStorage.setItem('scroll_top', window.pageYOffset);
  }
}
